import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AuthenticateService } from '../share/services/authenticate.service';
import { finalize } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertMessageComponent } from '../share/components/alert-message/alert-message.component';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.css']
})
export class RecoverPasswordComponent implements OnInit {

  form: FormGroup;
  submitted = false;
  sendMail = false;

  constructor(
    private formBuilder: FormBuilder,
    private authenticateService: AuthenticateService,
    private modalService: NgbModal
    ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      email: ['', Validators.required]
    });
  }
 
  get f() { return this.form.controls; }

  submit() {
    if (this.form.invalid) {
      return;
    }
    this.submitted = true;
    let email = this.f.email.value;
    this.authenticateService.forgot(email)
      .pipe(finalize(() => {
        this.submitted = false;
        //this.changeDetectorRef.detectChanges();
      }))
      .subscribe(
        (res) => {
          console.log("res ", res);
          this.sendMail = true;
        },
        (error) => {
          console.log("ERR ", error);
          if (error && error.error && error.error.statusCode) {
              
            const modalRef = this.modalService.open(AlertMessageComponent, { windowClass: 'animated fadeInDown' });
            let msg = '';
            if (error.error.statusCode == "USER_NOT_EXISTS") {
                modalRef.componentInstance.title = 'ERRORS.TITLE_USER_NOT_REGISTER';
                msg = 'REGISTER_NOT_FOUND';
            } else {
                msg = error.error.statusCode;
            }
            modalRef.componentInstance.msg = 'ERRORS.' + msg;

            modalRef.result.then((result) => {
            }, (reason) => {
            });
        }
        }
      )
  }

}
